import { create } from "axios";

export const http = create({
  baseURL: process.env.VUE_APP_MARSHALL_SERVICE_WEB_URL,
  params: {
    authToken: process.env.VUE_APP_MARSHALL_SERVICE_WEB_AUTH_TOKEN,
  },
});
